var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 6.763h-7.525V4.65c0-.5-.4-.9-.9-.9h-5.25c-.5 0-.9.4-.9.9v21.325c0 .5.4.9.9.9h5.262c.5 0 .9-.4.9-.9V15.25h7.525c2.35 0 4.25-1.9 4.25-4.25 0-2.338-1.912-4.237-4.262-4.237Zm0 6.024h-7.525v-3.55h7.525c.975 0 1.775.8 1.775 1.775a1.766 1.766 0 0 1-1.775 1.775Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4ZM0 4a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttendance);
export default ForwardRef;